import { StatusServiceMock } from "./status.types";

export const mockStatusService = (): StatusServiceMock => ({
  fetchStatuses: jest.fn(),
});
